<!-- Contenedor principal -->
<div class="flex flex-col w-full">
  <!-- Header -->
  <div class="sticky top-0 w-full">
    <div class="header-toolbar w-full bg-[#000F41] text-white flex items-center px-6 h-[6vh]">
      <!-- Lado izquierdo -->
      <div class="header-brand flex items-center gap-4">
        <img src="assets/Gea_Logo_Blanco.png" alt="logo GEA" class="h-[30px] cursor-pointer" routerLink="/" />
        <span class="header-brand-name text-white text-lg font-medium">| NPE Engineering Portal</span>
      </div>

      <!-- Centro -->
      <div class="header-context flex-1 flex justify-center items-center"
        [class.header-context-empty]="!ControlSystemsName" [title]="ControlSystemsName || ''">
        <span class="text-white text-lg font-semibold">
          {{ ControlSystemsName }}
        </span>
      </div>

      <!-- Login + Menú -->
      <div class="header-profile flex items-center gap-2 text-lg font-medium text-white relative">
        <button #profileButton type="button" class="header-profile-trigger flex items-center gap-2 cursor-pointer"
          (click)="toggleDropdown()" [attr.aria-expanded]="currentShowDropdown" aria-haspopup="true"
          [attr.aria-label]="'User menu: ' + (userLogin || 'n/a')" [title]="userLogin || 'n/a'">
          <span class="header-profile-label">{{ userLogin || 'n/a' }}</span>
          <span class="header-profile-avatar" aria-hidden="true">
            {{ userInitials }}
          </span>

          <!-- Icono del menú -->
          <div class="header-profile-chevron flex items-center gap-2">
            @if (!currentShowDropdown) {
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M1.3335 4.66669L8.00016 11.3334L14.6668 4.66669" stroke="#ffff" stroke-width="1.4"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            }
            @if (currentShowDropdown) {
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M14.6665 11.3333L7.99984 4.66665L1.33317 11.3333" stroke="#ffff" stroke-width="1.4"
                stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            }
          </div>
        </button>

        <!-- Menú desplegable -->
        @if (currentShowDropdown) {
        <div #profileMenu class="dropdown-menu-header" [ngStyle]="{ top: menuTop + 'px', right: menuRight + 'px' }"
          (click)="$event.stopPropagation()">
          <div class="header-profile-email">{{ userLogin || 'n/a' }}</div>
          <button type="button" class="dropdown-item flex items-center" (click)="logout(); $event.stopPropagation()">
            <geaui-icon-v3 file="logout" class="pl-5" [color]="'black'" [fileSize]="16"></geaui-icon-v3>
            <span class="pl-3">{{ 'UI-LIB.HEADER.LOGOUT' | translate }}</span>
          </button>
        </div>
        }
      </div>

    </div>
  </div>
</div>